module.exports = __webpack_public_path__ + "c87b78dd0d4db5e806d1a822115924b3.svg";